import { render, staticRenderFns } from "./EtcDocUploadPop.vue?vue&type=template&id=89430324"
import script from "./EtcDocUploadPop.vue?vue&type=script&lang=js"
export * from "./EtcDocUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89430324')) {
      api.createRecord('89430324', component.options)
    } else {
      api.reload('89430324', component.options)
    }
    module.hot.accept("./EtcDocUploadPop.vue?vue&type=template&id=89430324", function () {
      api.rerender('89430324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/EtcDocUploadPop.vue"
export default component.exports